import fetch from '@/utils/fetch';

// 招生报名统计
export function getEnrolAnalysisData(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolAnalysisData',
        method: 'post',
        data: params
    });
}

// 招生报名统计（出生月份）
export function getEnrolBirthMonthAnalysisData(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolBirthMonthAnalysisData',
        method: 'post',
        data: params
    });
}

// 获取通知列表不分页
export function getSchoolEnrolNoticeList(args) {
    let params = new URLSearchParams();
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolNoticeList',
        method: 'post',
        data: params
    });
}

export function getSchoolEnrolFieldList(args = {}) {
    let params = new URLSearchParams();
    if(args.yearNo) {
        params.append('yearNo', args.yearNo);
    }

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolFieldList',
        method: 'post',
        data: params
    });
}

// 按家长职业类型统计报名家长信息
export function getStaterunEnrolDutyTypeAnalysisDatas(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getStaterunEnrolDutyTypeAnalysisDatas',
        method: 'post',
        data: params
    });
}

// 按施教区统计学生数
export function getStaterunEnrolTeachAreaAnalysisDatas(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getStaterunEnrolTeachAreaAnalysisDatas',
        method: 'post',
        data: params
    });
}

// 按毕业学校统计学生数
export function getStaterunEnrolGraduateSchoolAnalysisDatas(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getStaterunEnrolGraduateSchoolAnalysisDatas',
        method: 'post',
        data: params
    });
}

// 线下一审统计
export function getEnrolOfflineOneAnalysisData(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolOfflineOneAnalysisData',
        method: 'post',
        data: params
    });
}

// 线下二审统计
export function getEnrolOfflineTwoAnalysisData(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolOfflineTwoAnalysisData',
        method: 'post',
        data: params
    });
}

// 各窗口取号人数统计
export function getWindowUserCountAnalysisDatas(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getWindowUserCountAnalysisDatas',
        method: 'post',
        data: params
    });
}

// 按家长学历类型统计报名家长信息
export function getStaterunEnrolEduValAnalysisDatas(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getStaterunEnrolEduValAnalysisDatas',
        method: 'post',
        data: params
    });
}

// 线上一审统计
export function getEnrolOnlineOneAnalysisDataList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolOnlineOneAnalysisDataList',
        method: 'post',
        data: params
    });
}

// 线上二审统计
export function getEnrolOnlineTwoAnalysisDataList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getEnrolOnlineTwoAnalysisDataList',
        method: 'post',
        data: params
    });
}
// 各窗口线下一审进度统计
export function getOfflineOneWindowUserCountDataList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getOfflineOneWindowUserCountDataList',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/primary/accounting.js